<template>
  <div class="code-container">
    <button class="copy-btn" @click="$emit('copy_code', source)" :title="$t('COMMON.COPY')">
      <i class="far fa-copy"></i>
    </button>
    <code class="code-content">
      {{ source }}
    </code>
  </div>
</template>

<script>
export default {
  name: 'CodeBox',
  props: ['source'],
  emits: ['copy_code']
};
</script>

<style scoped>
.code-container {
  position: relative;
  background-color: #f2f2f2;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-family: monospace;
  white-space: pre-wrap;
  word-break: break-all;
  overflow-x: auto;
}

.copy-btn {
  position: absolute;
  top: 8px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: #444;
}

.copy-btn:hover {
  color: #000;
}

.code-content {
  display: block;
  padding-top: 8px;
}
</style>
